module.exports = __webpack_public_path__ + "media/images/QA-1cb1c1baa6a07328fea96cdff31b80a3.svg";